import { useMemo, useState } from 'react';

interface UseDataToggleReturn<T, U> {
	showUnique: boolean;
	setShowUnique: (value: boolean) => void;
	currentData: T | U | undefined;
	hasError: boolean;
	canToggle: boolean;
}

export const useDataToggle = <T, U>(
	allData: T | undefined,
	uniqueData: U | undefined
): UseDataToggleReturn<T, U> => {
	const [showUnique, setShowUnique] = useState(true);

	const currentData = useMemo(() => {
		return showUnique ? uniqueData : allData;
	}, [showUnique, allData, uniqueData]);

	const hasError = useMemo(() => {
		if (showUnique) {
			return !uniqueData || (Array.isArray(uniqueData) && uniqueData.length === 0);
		}
		return !allData || (Array.isArray(allData) && allData.length === 0);
	}, [showUnique, allData, uniqueData]);

	const canToggle = useMemo(() => {
		return !!uniqueData && (Array.isArray(uniqueData) ? uniqueData.length > 0 : true);
	}, [uniqueData]);

	return {
		showUnique,
		setShowUnique,
		currentData,
		hasError,
		canToggle
	};
};
